














































































import { PRIVILEGE_KEYS } from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import ModalLinkRanchs from './ModalLinkRanchs.vue'
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import { getUrlRanchDetail, getUrlRanchSowingDetail } from '../utils';
import { InsuranceServices } from '../api/InsuranceServices';
import { ranchTypesOptions } from '../api/models';
import { HarvestRanchEditableFields } from '../ranch';


@Component({
    components: {
        Button,
        ModalLinkRanchs,
        DeleteConfirmation
    }
})
export default class RanchLinkButton extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({default: null}) currentRanchLink: object | null;
    @Prop({default: null}) currentItem: object;
    @Prop({default: false}) isSowing: boolean;
    @Prop({default: false}) loading: boolean;
    @Prop({default: false}) disableMenu: boolean;
    @Prop({default: -1}) farmingId: number;
    visibleModalLinkRanchs: boolean = false;
    unlinkingRanchs: boolean = false;
    selectedRanch: object = {};
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }
    
    deleteLinkConfirmation() {
        this.showDeleteConfirmationDialog(
            'Eliminar Link a Chacra',
            '¿Está seguro que desea eliminar el link de la chacra <b>' + this.currentItem['name'] + '</b>?' 
        );
    }
    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.unlinkRanch();
        } else {
            this.confirmationDelete = false;
        }
    }
   
    getTooltipLinkRanch(currentRanchLink){
        if(currentRanchLink && currentRanchLink.id){
            let ranchUrl = this.isSowing ? getUrlRanchDetail(currentRanchLink.id) : getUrlRanchSowingDetail(currentRanchLink.id)
            return `<span>Chacra vinculada: <a href='${ranchUrl}' target="_blank">${currentRanchLink.name}</a></span>`
        }
    }

    setRanchLink(){
        this.selectedRanch = {
            name: this.currentItem['name'],
            id: this.currentItem && this.currentItem['id'] ? this.currentItem['id'] : this.currentItem['ranch_id'] 
        }
        this.visibilityModalLinkRanchs(true);
    }

    visibilityModalLinkRanchs(value) {
        this.visibleModalLinkRanchs = value;
    }

    unlinkRanch(){
        this.unlinkingRanchs = true;
        this.$_showLoadingDialog('Desvinculando chacras...');
        let ranchId = this.currentItem && this.currentItem['ranch_id'] ? this.currentItem['ranch_id'] : this.currentItem['id'];
        let ranchType = this.isSowing ? ranchTypesOptions.sowing : ranchTypesOptions.harvest;
        if(ranchId){
            InsuranceServices.deslinkRanch(
                ranchId,
                ranchType
            ).then((response) =>{
                this.unlinkingRanchs = false;
                if(response && response.data && response.data.editable_fields){
                    this.updateEditableFields(response.data.editable_fields);
                }
                this.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'Chacra desvinculada con éxito',
                });
                   this.unlinkedRanchSuccess(ranchId);
            }).catch((error) =>{
                this.unlinkingRanchs = false;
                this.$_catchLoadingDialog({
                    response: error.response.data || {},
                    alternative_msg: 'No se pudo desvincular la chacra'
                });
            })
        }

    }

    @Emit()
    updateEditableFields(editableFields: HarvestRanchEditableFields){}

    @Emit()
    unlinkedRanchSuccess(ranchIdToRemoveLink){}

    @Emit()
    addNewLinkToRanch(newRanchLink, harvestRanchId){}
}
